import React from 'react';
import Container from 'react-bootstrap/Container';
import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';

const Footer = ({ children }) => {
  return (
    <footer className="footer mt-auto py-5 text-center">
      <Container>
        {children}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
          style={{ marginTop: '2rem' }}
        >
          <p style={{ 
            color: 'var(--text-secondary)',
            fontSize: '1rem',
            marginBottom: '0.5rem'
          }}>
            Made with{' '}
            <motion.span
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ 
                duration: 1,
                repeat: Infinity,
                repeatDelay: 2
              }}
              style={{ display: 'inline-block', color: '#e74c3c' }}
            >
              <Icon icon="fa:heart" />
            </motion.span>
            {' '}by{' '}
            <a
              rel="noopener"
              href="https://www.linkedin.com/in/rauniyarankit/"
              aria-label="My LinkedIn"
              style={{
                color: 'var(--text-primary)',
                textDecoration: 'none',
                fontWeight: 600,
                borderBottom: '2px solid transparent',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderBottomColor = 'var(--text-primary)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderBottomColor = 'transparent';
              }}
            >
              Ankit Rauniyar
            </a>
          </p>
          <p className="mt-2">
            <small style={{ 
              color: 'var(--text-secondary)',
              fontSize: '0.9rem'
            }}>
              &copy; {new Date().getFullYear()} Ankit Rauniyar. All rights reserved.
            </small>
          </p>
        </motion.div>
      </Container>
    </footer>
  );
};

export default Footer;
